import type React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'page.notFound' })

  return (
    <main className="flex h-screen flex-col items-center justify-center gap-4">
      <h1 className="text-4xl font-semibold">{t('code')}</h1>
      <p className="text-muted-foreground">{t('title')}</p>
      <Link to="/pulse" className="text-sm underline underline-offset-4">
        {t('backToDashboard')}
      </Link>
    </main>
  )
}

export default NotFoundPage
